import React, { useEffect, useState } from "react";
import Axios from "axios";
import TextField from "@mui/material/TextField";
import Navbar from "./Navbar";
import { useHistory } from "react-router-dom";
import Loading from "./Components/Loading";
import { message } from "antd";

function AddCourse() {
  const history = useHistory();

  const [price, setPrice] = useState(0);
  const [priceError, setPriceError] = useState(false);
  const [course, setCourse] = useState("");
  const [courseError, setCourseError] = useState(false);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Add Course";
  }, []);

  const addToList = () => {
    setPriceError(false);
    setCourseError(false);

    if (course === "") {
      setCourseError(true);
      return;
    }
    if (price === 0) {
      setPriceError(true);
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    Axios.post(
      "/api/course/insertCourse",
      {
        CourseName: course,
        CourseValue: price,
      },
      config
    )

      .then(function (response) {
        message.success(" Added successfully");
        setTimeout(function () {
          history.push("/courselist");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  return (
    <>
      {loading && <Loading />}
      <Navbar title="Add Course" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          style={{
            paddingLeft: "20px",
            paddingBottom: "10px",
            fontSize: "25px",
          }}
        >
          {/* <h2>Add Course</h2> */}
        </div>
        <div className="row mt-3 mb-4 pr-3 pl-3">
          <div className="col-lg-12">
            <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
              <div className="card-body">
                <div className="row form-group  " style={{ padding: "10px" }}>
                  <div className="col-lg-6">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Course Name"
                      onChange={(e) => setCourse(e.target.value)}
                      error={courseError}
                    />
                  </div>

                  <div className="col-lg-6">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      type="number"
                      id="outlined-required"
                      label="Course Price"
                      onChange={(e) => setPrice(e.target.value)}
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 6);
                      }}
                      error={priceError}
                    />
                  </div>
                </div>

                <div
                  className="float-right pr-3"
                  style={{ paddingTop: "40px" }}
                >
                  {" "}
                  <button
                    onClick={addToList}
                    className="btn btn-primary add-button"
                  >
                    {" "}
                    Add Course{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCourse;
